"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var list_1 = require("@prezzee/list");
var utils_1 = require("@prezzee/utils");
var button_base_1 = __importDefault(require("@prezzee/button-base"));
var style = __importStar(require("./MenuItem.style"));
var MenuItem = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, _a = props.autoFocus, autoFocus = _a === void 0 ? false : _a, _b = props.dense, dense = _b === void 0 ? false : _b, _c = props.divider, divider = _c === void 0 ? false : _c, _d = props.disableGutters, disableGutters = _d === void 0 ? false : _d, focusVisibleClassName = props.focusVisibleClassName, _e = props.role, role = _e === void 0 ? 'menuitem' : _e, tabIndexProp = props.tabIndex, other = __rest(props, ["children", "autoFocus", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex"]);
    var context = (0, react_1.useContext)(list_1.ListContext);
    var childContext = {
        dense: dense || context.dense || false,
        disableGutters: disableGutters,
    };
    var menuItemRef = (0, react_1.useRef)(null);
    (0, utils_1.useEnhancedEffect)(function () {
        if (autoFocus) {
            if (menuItemRef.current) {
                menuItemRef.current.focus();
            }
            else if (process.env.NODE_ENV !== 'production') {
                console.error('Unable to set focus to a MenuItem whose component has not been rendered.');
            }
        }
    }, [autoFocus]);
    var handleRef = (0, utils_1.useForkRef)(menuItemRef, ref);
    var tabIndex;
    if (!props.disabled) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }
    return ((0, jsx_runtime_1.jsx)(list_1.ListContext.Provider, __assign({ value: childContext }, { children: (0, jsx_runtime_1.jsx)(button_base_1.default, __assign({ component: 'li', css: style.root, ref: handleRef, 
            // role={role}
            tabIndex: tabIndex, focusVisibleClassName: focusVisibleClassName }, other, { children: children })) })));
});
exports.default = MenuItem;
//# sourceMappingURL=MenuItem.js.map